import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/index.js'

Vue.config.productionTip = false

// !引入vant组件
import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);

// 需要调试时打开
// import Vconsole from 'vconsole'
// const vConsole = new Vconsole()
// Vue.prototype.vConsole = vConsole;


import "./assets/resizeRem";
import './assets/css/global.scss';

// !过滤器
import * as filters from '@/utils/filters.js'
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})


// !全局方法
import * as methods from '@/utils/index.js'
Object.keys(methods).forEach(key => {
  Vue.prototype[key] = methods[key]
})


import { http } from './utils/request/manage.js'
Vue.prototype.$http = http


import wx from 'weixin-js-sdk';
Vue.prototype.$wx = wx


router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next();
})


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})


// WEBPACK FOOTER //
// ./src/main.js